import React, { useState } from "react";

import { createHocDisplayName } from "../../TypingUtils";

interface LoadedAttachmentProviderProps {
    children: React.ReactNode;
}

interface LoadedAttachmentContext {
    isFormEditorOpen: boolean;
    setIsFormEditorOpen: (isFormEditorOpen: boolean) => void;
}

export const LoadedAttachmentContext = React.createContext<LoadedAttachmentContext | null>(null);

export const LoadedAttachmentProvider = (props: LoadedAttachmentProviderProps) => {
    const [isFormEditorOpen, setIsFormEditorOpen] = useState(false);

    return (
        <LoadedAttachmentContext.Provider
            value={{ isFormEditorOpen: isFormEditorOpen, setIsFormEditorOpen: setIsFormEditorOpen }}>
            {props.children}
        </LoadedAttachmentContext.Provider>
    );
};

export const withLoadedAttachmentProvider = <P extends {}>(
    Component: React.ComponentType<P>
): React.ComponentType<P> => {
    function LoadedAttachment(props: P): JSX.Element {
        return (
            <LoadedAttachmentProvider>
                <Component {...props} />
            </LoadedAttachmentProvider>
        );
    }

    LoadedAttachment.displayName = createHocDisplayName(Component, "LoadedAttachment");

    return LoadedAttachment;
};
